import { rarityEnum } from "../enums/rarityEnum";
import api from "./BaseServices";

// Define the card interface for TypeScript
export interface CardData {
  id: number;
  blurred_image_id: string;
  small_image_id: string;
  image_id: string;
  booster_id?: string;
  logo_id: string;
  border_color: string;
  orb: string;
  name: string;
  credit: string;
  description: string;
  title: string;
  blur_level: string;
  rarity: rarityEnum;
  is_in_store: boolean;
  price: number;
  created_at: Date;
  updated_at: Date;
}

export interface ShowCardsType extends CardData {
  booster_image: string;
  booster_name: string;
}

export interface GenerateCardData extends CardData {
  logo_file: Blob | null;
  text_color: string | null;
  offset_y: number;
  offset_x: number;
  width: number;
  zoom: number;
  image_file: Blob;
}

interface BoosterDetails {
  id: number;
  name: string;
  image_id: string;
}

export interface deleteCardsResult {
  deletedIds: number[];
  errors: {
    boosterCards: BoosterDetails[];
    collectorCards: number[];
  };
}

// API base URL (replace with your backend API base URL)
const API_URL = `${process.env.REACT_APP_API_URL}/cards`; // Modify this if your API is on a different URL

// Function to fetch all cards with pagination (limit and offset)
export const getCreatorCards = async (
  limit: number,
  offset: number
): Promise<ShowCardsType[]> => {
  const response = await api.get(API_URL, {
    params: {
      limit,
      offset,
    },
  });
  return response.data;
};

export const getCreatorArchivedCards = async (
  limit: number,
  offset: number
): Promise<ShowCardsType[]> => {
  const response = await api.get(`${API_URL}/archived`, {
    params: {
      limit,
      offset,
    },
  });
  return response.data;
};

// Function to fetch a single card by ID
export const getCardById = async (id: number): Promise<string> => {
  const response = await api.get(`${API_URL}/${id}`);
  return decodeURI(response.data.signed_url);
};

// Function to update an existing card
export const updateCard = async (
  id: number,
  card: Partial<Omit<CardData, "id" | "created_at" | "updated_at">>
): Promise<CardData> => {
  const response = await api.put(`${API_URL}/${id}`, card);
  return response.data;
};

// Function to delete a card by ID
export const deleteCard = async (id: number): Promise<boolean> => {
  const response = await api.delete(`${API_URL}/${id}`);
  return response.status === 200;
};

export const deleteCards = async (
  ids: number[]
): Promise<deleteCardsResult> => {
  const response = await api.delete(API_URL, {
    data: { ids },
  });

  return response.data;
};

export const archiveCards = async (ids: number[]): Promise<boolean> => {
  const response = await api.put(`${API_URL}/archive`, { ids: ids });
  return response.status === 200;
};

// Function to fetch all boosters associated with a specific card
// export const getBoostersForCard = async (cardId: number): Promise<any[]> => {
//
//     // Replace `API_URL` with the correct endpoint for fetching boosters associated with a card
//     const response = await api.get(`${API_URL}/${cardId}/boosters`, {
//
//     });
//     return response.data; // Returning the list of boosters
//   } catch (error) {
//     console.error(`Error fetching boosters for card ${cardId}:`, error);
//     throw new Error("Error fetching boosters for card");
//   }
// };

export const generateCard = async (
  cardData: Omit<
    GenerateCardData,
    | "id"
    | "created_at"
    | "updated_at"
    | "blurred_image_id"
    | "image_id"
    | "small_image_id"
    | "logo_id"
    | "is_in_store"
    | "price"
    | "booster_id"
    | "blur_level"
  >
): Promise<any> => {
  console.log(cardData);

  const response = await api.post(`${API_URL}/generate/`, cardData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};
